// frontend/src/services/sourceService.js
// 來源管理服務 - 前端 API 封裝

import api from './api';

/**
 * 取得所有啟用中的來源（公開 API，供上傳頁面使用）
 * GET /api/sources/all-active
 * 回傳所有 is_active=true 的來源，不過濾有無文件
 * @returns {Promise<Object>} 啟用中的來源列表
 */
export const getAllActiveSourcesForUpload = async () => {
  const response = await api.get('/sources/all-active');
  return response.data;
};

/**
 * 取得啟用中的來源（公開 API，供搜尋頁面篩選使用）
 * GET /api/sources/active
 * 只回傳有文件的來源
 * @returns {Promise<Object>} 啟用中的來源列表（含文件數）
 */
export const getActiveSources = async () => {
  const response = await api.get('/sources/active');
  return response.data;
};

/**
 * 取得所有來源（含文件數統計）
 * GET /api/admin/sources
 * @returns {Promise<Object>} 來源列表
 */
export const getAllSources = async () => {
  const response = await api.get('/admin/sources');
  return response.data;
};

/**
 * 取得單一來源
 * GET /api/admin/sources/:id
 * @param {number} id - 來源 ID
 * @returns {Promise<Object>} 來源資料
 */
export const getSource = async (id) => {
  const response = await api.get(`/admin/sources/${id}`);
  return response.data;
};

/**
 * 新增來源
 * POST /api/admin/sources
 * @param {Object} sourceData - 來源資料
 * @param {string} sourceData.code - 來源代碼
 * @param {string} sourceData.name - 來源名稱
 * @param {string} [sourceData.description] - 來源描述
 * @param {boolean} [sourceData.is_active] - 是否啟用
 * @returns {Promise<Object>} 新增結果
 */
export const createSource = async (sourceData) => {
  const response = await api.post('/admin/sources', sourceData);
  return response.data;
};

/**
 * 更新來源
 * PUT /api/admin/sources/:id
 * @param {number} id - 來源 ID
 * @param {Object} sourceData - 更新資料
 * @param {string} [sourceData.name] - 來源名稱
 * @param {string} [sourceData.description] - 來源描述
 * @param {boolean} [sourceData.is_active] - 是否啟用
 * @returns {Promise<Object>} 更新結果
 */
export const updateSource = async (id, sourceData) => {
  const response = await api.put(`/admin/sources/${id}`, sourceData);
  return response.data;
};

/**
 * 刪除來源
 * DELETE /api/admin/sources/:id
 * @param {number} id - 來源 ID
 * @param {string} [transferTo] - 轉移文件到此來源代碼
 * @returns {Promise<Object>} 刪除結果
 */
export const deleteSource = async (id, transferTo = null) => {
  const params = transferTo ? { transferTo } : {};
  const response = await api.delete(`/admin/sources/${id}`, { params });
  return response.data;
};

const sourceService = {
  getAllActiveSourcesForUpload,
  getActiveSources,
  getAllSources,
  getSource,
  createSource,
  updateSource,
  deleteSource,
};

export default sourceService;
